export const makeHttpParamExtractor = (headers) => (key) => {
    const value = headers[key.toLowerCase()];
    if (Array.isArray(value)) {
        return value[0];
    }
    else {
        return value;
    }
};
